.gz{gap:0.25rem;}